import { es } from '../translations/es';

export const useTranslation = () => {
  return {
    t: (key: string) => {
      const keys = key.split('.');
      let value: any = es;
      
      for (const k of keys) {
        if (value && typeof value === 'object' && k in value) {
          value = value[k];
        } else {
          return key; // Return the key if translation not found
        }
      }
      
      return typeof value === 'string' ? value : key;
    },
    translations: es
  };
}; 